import React, { Component } from 'react';
import { Row, Field, Label }  from '../../generic';
import TextInput from '../../generic/fields/TextInput';
import TextArea from '../../generic/fields/TextArea';
import RadioInput from '../../generic/fields/RadioInput';
import Select from '../../generic/fields/Select';
import { validRadio } from '../../../helpers/check-required-fields';
import styled from 'styled-components';

const Hint = styled.div`
  color: rgba(0,0,0,0.6);
  margin-top: 7px;
`

class Where extends Component {
  render() {
    const { userEvent, onChange } = this.props
    return (
      <React.Fragment>
        <Row>
          <h2 style={{marginBottom: '20px'}}>Event Location and Access</h2>

          <Label value="How do you want people to gather?" required={true} />
          <div><RadioInput name="userEvent[event_type]" onChange={onChange} checked={validRadio(userEvent.event_type, 'online')} value={'online'} label="Online Only"/></div>
          <div><RadioInput name="userEvent[event_type]" onChange={onChange} checked={validRadio(userEvent.event_type, 'in_person')} value={'in_person'} label="In-Person Only"/></div>
          <div><RadioInput name="userEvent[event_type]" onChange={onChange} checked={validRadio(userEvent.event_type, 'online_in_person')} value={'online_in_person'} label="Online + In-Person"/></div>

          {['online', 'online_in_person'].indexOf(userEvent.event_type) > -1 && <React.Fragment>
            <h2 style={{margin: '35px 0 20px'}}>Online Guests</h2>
            <Field name="userEvent[online_url]" error={false}>
              <Label value="Online meeting URL" />
              <TextInput autoFocus="true" value={userEvent.online_url} onChange={onChange} />
              <Hint>Full URL including https://{/*New to online meeting tools? <a target="_blank" href='/'>Learn More</a>.*/}</Hint>
            </Field>
          </React.Fragment>}

          {['in_person', 'online_in_person'].indexOf(userEvent.event_type) > -1 && <React.Fragment>
            <h2 style={{margin: '35px 0 20px'}}>In-Person Guests</h2>
            <Field name="userEvent[address_description]" error={false} hint="E.g. Jane's House, Restaurant name, Business name">
              <Label value="Location Name" />
              <TextInput autoFocus="true" value={userEvent.address_description} onChange={onChange} />
            </Field>
            <Field name="userEvent[address_1]" error={false}>
              <Label value="Address" required={true} />
              <TextInput value={userEvent.address_1} onChange={onChange} />
            </Field>
            <Field name="userEvent[city]" error={false}>
              <Label value="City" required={true} />
              <TextInput value={userEvent.city} onChange={onChange} />
            </Field>
            <Field name="userEvent[province]" error={false}>
              <Label value="Province" required={true} />
              <Select value={userEvent.province} onChange={onChange}>
                <option value="Alberta">Alberta</option>
                <option value="British Columbia">British Columbia</option>
                <option value="Manitoba">Manitoba</option>
                <option value="New Brunswick">New Brunswick</option>
                <option value="Newfoundland and Labrador">Newfoundland and Labrador</option>
                <option value="Nova Scotia">Nova Scotia</option>
                <option value="Ontario">Ontario</option>
                <option value="Prince Edward Island">Prince Edward Island</option>
                <option value="Quebec">Quebec</option>
                <option value="Saskatchewan">Saskatchewan</option>
                <option value="Northwest Territories">Northwest Territories</option>
                <option value="Nunavut">Nunavut</option>
                <option value="Yukon">Yukon</option>
              </Select>
            </Field>
            <Field name="userEvent[postal_code]" error={false} hint="E.g. V5Y 1V4">
              <Label value="Postal Code" required={true} />
              <TextInput value={userEvent.postal_code} onChange={onChange} />
            </Field>
          </React.Fragment>}

          <h2 style={{margin: '35px 0 20px'}}>Event Access<span style={{color: 'red'}}>*</span></h2>

          <div>
            <RadioInput name="userEvent[public_access]" onChange={onChange} checked={validRadio(userEvent.public_access, false)} value={false} label="My event is private"/>
          </div>
          <div>
            <RadioInput name="userEvent[public_access]" onChange={onChange} checked={validRadio(userEvent.public_access, true)} value={true} label="My event is public"/>
          </div>

          <Field style={{marginTop: '20px'}} name="userEvent[extra_directions]" error={false} hint="E.g. buzzer number, online conferencing password, transit/parking notes">
            <Label value="Extra Directions and Notes" />
            <TextArea value={userEvent.extra_directions} onChange={onChange} rows="3" />
          </Field>
        </Row>
      </React.Fragment>
    )
  }
}

export default Where
